import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    },
    changeItem (state, item) {
      const items = state.items.filter((i) => i.id !== item.id)
      state.items = [...items, item]
    }
  },
  getters: {
    getItem: (state) => (id) => {
      const shearchId = parseInt(id)
      return state.items.find((i) => i.id === shearchId)
    }
  },
  actions: {
    getList ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.campaignsCpcInfluencer(token)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getOne ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignCpcInfluencer(token, campaignId)
            .then((res) => {
              commit('changeItem', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    join ({ commit, state, dispatch }, id) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.joinCampaignsCpcInfluencer(token, id)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
